import React from 'react';

import { Animation } from 'components/lottie-animations/logo';

type Props = {
  width?: string;
  height?: string;
};

const Logo: React.FC<Props> = props => (
  <React.Suspense fallback={null}>
    <Animation {...props} />
  </React.Suspense>
);

export default Logo;
